import {
  MotorcycleProductIntroFormValues,
  MotorcycleTexts,
} from "../motorcycleInterface";
import {
  getBonusOptions,
  getSnowmobileBonusOptions,
} from "../motorcycleUtils/formElementsOptions";

import { VEHICLE_TYPE } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/vehicleConstants";
import { Select } from "Components/Form/Select";
import { TextLanguage } from "Store/texts/interfaces";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { FindVehicleType } from "../../Car/ProductIntro/FormElements/FindVehicleType";
import { findVehicleTextsMotorcycle } from "../../Car/ProductIntro/FormElements/FindVehicleType/utils";

interface Props {
  formProps: FormikProps<MotorcycleProductIntroFormValues>;
  texts: MotorcycleTexts["formText"]["checkPrice"];
  lang: TextLanguage;
}

export const FormElements = (props: Props): React.ReactElement => {
  const { texts, lang, formProps } = props;
  const brand = formProps.values.brand;
  const isSnowmobile =
    isDefined(brand) && brand !== "" && brand.startsWith("SNØSCOOTER");
  const bonusOptions = isSnowmobile
    ? getSnowmobileBonusOptions(texts.bonus.options, lang)
    : getBonusOptions(texts.bonus.options, lang);

  return (
    <>
      <FindVehicleType
        vehicleType={VEHICLE_TYPE.MOTORCYCLE}
        vehicleFetched={false}
        formProps={formProps}
        texts={findVehicleTextsMotorcycle}
      />
      <Select
        large
        name="bonus"
        id="bonus"
        label={texts.bonus.label[lang]}
        hint={texts.bonus.hint[lang]}
        options={bonusOptions}
        error={getError("bonus", formProps)}
      />
    </>
  );
};
